import {schema} from 'normalizr'
import {organizationDepartmentSchema, organizationSchema} from './organization'
import {userSchema} from './user'

export const pollSchema = new schema.Entity(
    'polls',
    {
        creator: new schema.Union(
            {
                user: userSchema,
                organization: organizationSchema,
                organization_department: organizationDepartmentSchema,
            },
            '_type'
        ),
    },
    {
        idAttribute: 'idname',
    }
)
